import { ApplicationActionType } from '../../../ApplicationConstants';
import { performCellDoubleClick } from './onCellDblClick';

export const onCellDblClickAppraisalReview = (e) => {
    performCellDoubleClick(e, ApplicationActionType.AppraisalReview);
};
